// src/api/hospitalDashboardApi.js
import httpClient from "api/httpClient";

const API_BASE = process.env.REACT_APP_API_URL;

export const hospitalDashboardApi = {
  getHospitalDashboardData: async () => {
    const response = await httpClient.get(`${API_BASE}/api/hospital/dashboard/data`);
    return response.data;
  },
};
